import React from 'react';
import { IonTabs, IonRouterOutlet, IonTabBar, IonTabButton, IonIcon, IonLabel } from '@ionic/react';
import { Route, Redirect } from 'react-router';
import Parameters from '../pages/Parameters';
import { bookOutline, albumsOutline, statsChartOutline, cog } from 'ionicons/icons';
import Diary from '../pages/Diary';
import NewMeal from '../pages/NewMeal';
import MealPage from '../pages/MealPage';
import Flow from '../pages/Flow';
import QRCodePage from '../pages/QRCodePage';
import MealStats from '../pages/MealStats';
import MealsStats from '../pages/MealsStats';


const MainTabs: React.FC = () => {
  return (
    <IonTabs>
      <IonRouterOutlet>
        <Route path="/home/meals" exact render={() => <Diary />} />
        <Route path="/home/meals/new" exact render={() => <NewMeal />} />
        <Route path="/home/meals/:mealId/stats" exact render={() => <MealStats />} />
        <Route path="/home/meals/:mealId" exact render={() => <MealPage ownerFlag />} />
        <Route path="/home/flow" render={() => <Flow />} exact />
        <Route path="/home/flow/qrcode" exact render={() => <QRCodePage />} />
        <Route path="/home/flow/:mealId" exact render={() => <MealPage />} />
        <Route path="/home/progress" render={() => <MealsStats />} exact/>
        <Route path="/home/parameters" component={Parameters} exact/>
        <Route path="/home" render={() => <Redirect to="/home/meals" />} exact />
      </IonRouterOutlet>
      <IonTabBar slot="bottom" className='ion-padding'>
        <IonTabButton tab="meals" href="/home/meals">
          <IonIcon icon={bookOutline} />
          <IonLabel>Mon carnet</IonLabel>
        </IonTabButton>
        <IonTabButton tab="flow" href="/home/flow">
          <IonIcon icon={albumsOutline} />
          <IonLabel>Flux</IonLabel>
        </IonTabButton>
        <IonTabButton tab="progress" href="/home/progress">
          <IonIcon icon={statsChartOutline} />
          <IonLabel>Mon suivi</IonLabel>
        </IonTabButton>
        <IonTabButton tab="parameters" href="/home/parameters">
          <IonIcon icon={cog} />
          <IonLabel>Paramètres</IonLabel>
        </IonTabButton>
      </IonTabBar>
    </IonTabs>
  );
};

export default MainTabs;
